import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';

const MidtownStudioCallout = () => (
  <Link
    to="/massage-midtown-sacramento"
    className="group mt-12 flex flex-col sm:flex-row sm:items-center gap-4 bg-white border border-teal-200 rounded-2xl p-6 hover:border-teal-500 hover:shadow-lg transition-[border-color,box-shadow] duration-300 not-prose"
    data-testid="midtown-studio-callout"
  >
    <span className="w-12 h-12 shrink-0 rounded-full bg-teal-50 text-teal-700 flex items-center justify-center">
      <MapPin className="w-6 h-6" />
    </span>
    <span className="flex-1">
      <span className="block text-xs uppercase tracking-widest text-teal-700">Visiting the studio?</span>
      <span className="block mt-1 font-serif text-lg text-gray-900">
        Massage therapy in Midtown Sacramento — map, parking, hours & pricing for 2528 I Street
      </span>
    </span>
    <ArrowRight className="w-5 h-5 text-teal-700 group-hover:translate-x-1 transition-transform duration-300" />
  </Link>
);

export default MidtownStudioCallout;
